const ladyLoading = url => () => import(`../views/${url}.vue`)
const Empty = () => import(`@core/router/Empty.vue`)
const invoiceReConfirmNew = () => import(`@src/area-dcits/views/invoicestration/operationalbilling/InvoiceReConfirmNew.vue`)
const invoiceReChangeNew = () => import(`@src/area-dcits/views/invoicestration/operationalbilling/invoiceReChangeNew.vue`)

// 新工作流发起
// 重新提交页面
const invoiceReConfirmNewStart = () => import(`@src/area-dcits/views/invoicestration/operationalbilling/InvoiceReConfirmNewStart.vue`)
const invoiceReChangeNewStart = () => import(`@src/area-dcits/views/invoicestration/operationalbilling/invoiceReChangeNewStart.vue`)

const handlingPage = ladyLoading('handlingPage/index')
const handlePage = ladyLoading('handlingPage/indexPage')
const handleInfo = ladyLoading('handlingPage/baseInfo/todoDetail')
const systemNotice = ladyLoading('mynotice/systemNotice')
const serveNotice = ladyLoading('mynotice/serveNotice')
const circleNotice = ladyLoading('mynotice/circleNotice')

// import invoiceRouter from '../../area-dcits/routerDcits/invoiceRouter.js'

// const serivceApp = ladyLoading('Home/serviceHome')
const routes = {
  path: 'notice',
  name: 'notice',
  component: Empty,
  title: '待办及通知',
  redirect: 'notice/mylist/todolist',
  meta: {
    menuId: 'M1005001',
    zhname: '待办及通知',
    type: 'menu',
    aside: true,
    closeable: true
  },
  children: [
    // 我的待办路由组
    {
      path: 'mylist',
      name: 'mylist',
      component: Empty,
      meta: {
        menuId: 'global',
        type: 'menu',
        zhname: '我的待办',
        icon: 'appoint'
      },
      children: [
        // 待办事项路由
        {
          path: 'todolist',
          name: 'todoList',
          // component: c,
          component: handlingPage,
          children: [],
          meta: {
            menuId: 'global',
            type: 'menu',
            zhname: '待办事项',
            icon: 'appoint'
          }
        },
        // 已办事项路由
        {
          path: 'donelist',
          name: 'doneList',
          component: handlePage,
          children: [],
          meta: {
            menuId: 'global1',
            type: 'menu',
            zhname: '已办事项',
            icon: 'appoint'
          }
        },
        // 开票申请路由
        {
          path: 'invoiceConfirm',
          name: 'invoiceConfirm',
          component: handleInfo,
          children: [],
          meta: {
            menuId: 'global2',
            type: 'btn',
            zhname: '开票申请',
            icon: 'appoint'
          }
        },
        // 发票换开申请路由
        {
          path: 'invoiceChange',
          name: 'invoiceChange',
          component: handleInfo,
          children: [],
          meta: {
            menuId: 'global2',
            type: 'btn',
            zhname: '发票换开申请',
            icon: 'appoint'
          }
        }
      ]
    },

    // 待办详情路由
    {
      path: 'tododetail',
      name: 'todoDetail',
      component: handleInfo,
      children: [],
      meta: {
        aside: true,
        type: 'btn',
        zhname: '待办详情',
        icon: 'appoint'
      }
    },
    // 已办详情路由
    {
      path: 'donedetail',
      name: 'doneDetail',
      component: handleInfo,
      children: [],
      meta: {
        aside: true,
        type: 'btn',
        zhname: '已办详情',
        icon: 'appoint'
      }
    },
    // 我的消息路由组
    {
      path: 'mynotice',
      name: 'mynotice',
      component: Empty,
      meta: {
        menuId: 'M1005001001',
        type: 'menu',
        zhname: '我的消息',
        icon: 'serveNotice'
      },
      children: [
        // 服务消息路由
        {
          path: 'serve',
          name: 'serveNotice',
          component: serveNotice,
          meta: {
            menuId: 'M1005001001',
            type: 'menu',
            zhname: '服务消息',
            icon: 'serveNotice'
          },
          children: []
        },
        // 系统通知路由
        {
          path: 'system',
          name: 'systemNotice',
          component: systemNotice,
          meta: {
            menuId: 'M1005001001003',
            type: 'menu',
            zhname: '系统通知',
            icon: 'systemNotice'
          },
          children: []
        },
        // 园圈动态路由
        {
          path: 'circle',
          name: 'circleNotice',
          component: circleNotice,
          meta: {
            menuId: 'M1005002009002Y',
            type: 'menu',
            zhname: '园圈动态',
            icon: 'circleNotice'
          },
          children: []
        }
      ]
    },
    // 通知详情路由（带参数）
    {
      path: 'noticedetail',
      name: 'noticeDetail',
      component: handleInfo,
      children: [],
      meta: {
        type: 'btn',
        aside: true,
        zhname: '通知详情'
      }
    },
    // 富文本通知详情路由（带参数）
    {
      path: 'richtext/:id',
      name: 'richText',
      // component: p,
      children: [],
      meta: {
        type: 'btn',
        aside: true,
        zhname: '通知详情',
        icon: 'systemNotice'
      }
    },
    // 入住/迁出消息路由
    {
      path: 'apartmentmessage',
      name: 'apartmentmessage',
      // component: d,
      children: [],
      meta: {
        type: 'btn',
        aside: true,
        zhname: '入住/迁出消息',
        icon: 'systemNotice'
      }
    },

    {
      path: 'invoiceReChangeNew',
      name: 'invoiceReChangeNew',
      component: invoiceReChangeNew,
      meta: {
        zhname: '发票换开申请',
        menuId: 'global',
        type: 'btn',
        icon: 'accountModify',
        aside: true
      }
    },
    {
      path: 'invoiceReConfirmNew',
      name: 'invoiceReConfirmNew',
      component: invoiceReConfirmNew,
      meta: {
        zhname: '发票开票申请',
        menuId: 'global',
        type: 'btn',
        icon: 'accountModify',
        aside: true
      }
    },
    {
      path: 'invoiceReChangeNewStart',
      name: 'invoiceReChangeNewStart',
      component: invoiceReChangeNewStart,
      meta: {
        zhname: '发票换开申请',
        menuId: 'global',
        type: 'btn',
        icon: 'accountModify',
        aside: true
      }
    },
    {
      path: 'invoiceReConfirmNewStart',
      name: 'invoiceReConfirmNewStart',
      component: invoiceReConfirmNewStart,
      meta: {
        zhname: '发票开票申请',
        menuId: 'global',
        type: 'btn',
        icon: 'accountModify',
        aside: true
      }
    },
    {
      path: 'myapply',
      name: 'myapply',
      component: Empty,
      meta: {
        menuId: 'globalApply',
        type: 'menu',
        zhname: '我的申请',
        icon: 'appoint'
      },
      children: [
        // 待办事项路由
        {
          path: 'todoApplylist',
          name: 'todoApplyList',
          // component: c,
          component: handlingPage,
          children: [],
          meta: {
            menuId: 'globalApply',
            type: 'menu',
            zhname: '待办申请',
            icon: 'appoint'
          }
        },
        // 已办事项路由
        {
          path: 'doneApplylist',
          name: 'doneApplyList',
          component: handlePage,
          children: [],
          meta: {
            menuId: 'globalApply1',
            type: 'menu',
            zhname: '已办申请',
            icon: 'appoint'
          }
        }
      ]
    }
  ]
}
export default routes



// WEBPACK FOOTER //
// ./src/area-index-page/router/znotice.js